<!-- <div class="switch" *ngIf="activity.showHideExpirationDateOption">
  <label>
    <input type="checkbox" [(ngModel)]="activity.hideExpirationDate" />
    Hide Expiration Date
  </label>
</div> -->

<wm-form-activity-editor
  [activity]="activity"
  [form]="form"
  [workflow]="workflow"
  [includedDataEntityTypes]="includedDataEntityTypes"
  [excludedDataEntityTypes]="excludedDataEntityTypes"
  (saved)="saved.emit($event)"
></wm-form-activity-editor>

<div class="switch" *ngIf="isGlobalAdmin">
  <label>
    <input type="checkbox" [(ngModel)]="activity.allowApplicantAsRole" />
    Allow Applicant as Role
  </label>
</div>
